import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4AB5D8",
    },
    secondary: {
      main: "#13436D",
    },
  },
});

export default theme;
